import * as React from "react";
import { cn } from "lib/cn";

export type TextAreaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextArea = React.forwardRef(({ className, ...props }: TextAreaProps, ref) => {
    return (
        <textarea
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            ref={ref as any}
            className={cn(
                "focus:ring-brand-atlantic rounded-lg border border-solid border-[#c8c8c8] bg-[#eeeeee] px-2 py-2 placeholder-gray-400 focus:outline-none focus:ring-2",
                className,
            )}
            {...props}
        />
    );
});
